import React from 'react'
import Footer from '../components/Footer/Footer'
import NavbarContainer from '../components/NavbarContainer/NavbarContainer'
import CommonHeader from '../components/CommonHeader/CommonHeader'
import Services from '../components/Services/Services'
import { useSelector } from 'react-redux';

function Aboutus() {
          const { currentLocal } = useSelector((state) => state.currentLocal);

  return (
    <div>
      <NavbarContainer/>
            <CommonHeader
      title={currentLocal.home.aboutafaq}
      />
      <Services/>
      <Footer/>

    </div>
  )
}

export default Aboutus